<div class="container">

</div>
<div class="row">


  <div class="col-md-8">
    <h2 class="content-block"><i class="fa-solid fa-database"></i> Admin Data</h2>
    <dx-data-grid
      [dataSource]="adminDatas"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createAdminData($event)"
      (onRowUpdating)="updateAdminData($event)"
      (onRowRemoved)="deleteAdminData($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
      type="buttons"
      width="110"
    >
      <dxi-button
        name="edit"
        icon="edit"
        hint="Düzenle"
      ></dxi-button>
    </dxi-column>

      <dxi-column
        dataField="name"
        caption="Ad"
        [allowEditing]="false"
      >
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="letterCount"
        caption="Harf Sayısı"
        cellTemplate="letterCountTemplate"
        [width]="150"
        [allowFiltering]="false"
        [allowEditing]="false"
        >
      </dxi-column>

      <dxi-column dataField="description" caption="Değer">
      </dxi-column>
      <div
            *dxTemplate="let cellInfo of 'letterCountTemplate'"
            class="name-template"
          >
            <div>
              {{ getLetterCount(cellInfo.row.data) }}
            </div>
          </div>
    </dx-data-grid>
  </div>

  <!-- <div class="col-md-6">
    <h2 class="content-block">Site Logo</h2>
    <app-image-uploader
      (fileSelected)="onFileSelectedLogo($event)"
      [src]="siteLogoDto.description"
    ></app-image-uploader>
    <dx-button
      type="success"
      text="Kaydet"
      class="mt-4"
      icon="save"
      (onClick)="saveLogo()"
    ></dx-button>
  </div> -->
  <div class="col-md-4">
    <h2 class="content-block"><i class="fa-solid fa-font-awesome"></i> Site Logo</h2>
    <div  class="content-block card responsive-paddings">
      <div class="col-md-4">
        <app-image-uploader
          (fileSelected)="onFileSelectedSlider($event)"
          [src]="sliderImageDto.description"
        ></app-image-uploader>
      </div>
      <dx-button
      type="success"
      text="Kaydet"
      class="col-3 mt-4"
      icon="save"
      (onClick)="saveSlider()"
    ></dx-button>
    <div class="mt-2">Not: Genişlik 900px, yükseklik 600px olacak şekilde resim ekleyiniz</div>
    </div>

  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-address-book"></i> İletişim Bilgileri</h2>
    <dx-data-grid
      [dataSource]="contacts"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createContact($event)"
      (onRowUpdating)="updateContact($event)"
      (onRowRemoved)="deleteContact($event)"
    >
      <!-- <dxo-paging [enabled]="true"></dxo-paging> -->
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
      type="buttons"
      width="50"
    >
      <dxi-button
        name="edit"
        icon="edit"
        hint="Düzenle"
      ></dxi-button>
    </dxi-column>
      <dxi-column dataField="title" caption="Başlık">
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="address" caption="Adres">
        <dxi-validation-rule
          type="required"
          message="Address is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="phone" caption="Telefon">
        <!-- <dxi-validation-rule
          type="required"
          message="Phone is required"
        ></dxi-validation-rule> -->
      </dxi-column>
      <dxi-column dataField="whatsapp" caption="Whatsapp"> </dxi-column>
      <dxi-column dataField="email" caption="Mail"> </dxi-column>
      <dxi-column dataField="mernisNo" caption="Mernis No"> </dxi-column>
      <dxi-column dataField="taxNumber" caption="Vergi Numarası"> </dxi-column>
        <dxi-column dataField="companyName" caption="Firma Adı">   <dxi-validation-rule
          type="required"
          message="Comapny Name is required"
        ></dxi-validation-rule> </dxi-column>
      <dxi-column dataField="locationLink" caption="Konum Linki"> </dxi-column>
      <dxi-column dataField="metaKeyword" caption="Meta Keyword"> </dxi-column>
      <dxi-column dataField="metaDescription" caption="Meta Description">
      </dxi-column>
    </dx-data-grid>
  </div>
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-comment-sms"></i> Sms Operatör Bilgileri</h2>
    <dx-data-grid
      [dataSource]="smsAccounts"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createSmsAccount($event)"
      (onRowUpdating)="updateSmsAccount($event)"
      (onRowRemoved)="deleteSmsAccount($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
      type="buttons"
      width="50"
    >
      <dxi-button
        name="edit"
        icon="edit"
        hint="Düzenle"
      ></dxi-button>
    </dxi-column>
      <dxi-column dataField="name" caption="İsim">
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="smsService" caption="Servis Sağlayıcı">
        <dxi-validation-rule
          type="required"
          message="smsService is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="userName" caption="Kullanıcı Adı">
        <dxi-validation-rule
          type="required"
          message="User Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="password" caption="Şifre">
        <dxi-validation-rule
          type="required"
          message="Password Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="gsmNumber" caption="Telefon Numarası">
        <dxi-validation-rule
          type="required"
          message="Gsm Number Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="originator" caption="Originator Numarası">
        <dxi-validation-rule
          type="required"
          message="Originator Name is required"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>



</div>

<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-comment-sms"></i> Sms Şablon Bilgileri</h2>
    <dx-data-grid
      [dataSource]="smsTemplates"
      keyExpr="id"
      class="content-block card responsive-paddings"
      (onRowInserting)="createSmsTemplate($event)"
      (onRowUpdating)="updateSmsTemplate($event)"
      (onRowRemoved)="deleteSmsTemplate($event)"
    >
      <dxo-editing
        mode="popup"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
      type="buttons"
      width="50"
    >
      <dxi-button
        name="edit"
        icon="edit"
        hint="Düzenle"
      ></dxi-button>
    </dxi-column>
      <dxi-column dataField="name" caption="İsim" [allowEditing]="false">
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="body" caption="İçerik">
        <dxi-validation-rule
          type="required"
          message="Body is required"
        ></dxi-validation-rule>
        <dxo-form-item
          editorType="dxTextArea"
          [editorOptions]="{ height: 120, autoResizeEnabled: true }"
        >
        </dxo-form-item>
      </dxi-column>
      <dxi-column
        dataField="replacedValues"
        caption="Özel İfadeler"
        [visible]="false"
      >
        <dxo-form-item
          editorType="dxTextArea"
          [editorOptions]="{ height: 120, autoResizeEnabled: true }"
        >
        </dxo-form-item>
      </dxi-column>
    </dx-data-grid>
  </div>

  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-envelopes-bulk"></i> Smtp Bilgileri</h2>
    <dx-data-grid
      [dataSource]="smtps"
      keyExpr="id"
      class="content-block card responsive-paddings"
      style="padding-top:32px"
      (onRowInserting)="createSmtp($event)"
      (onRowUpdating)="updateSmtp($event)"
      (onRowRemoved)="deleteSmtp($event)"
      (onInitNewRow)="onInitNewRowSmtp($event)"
    >
      <dxo-editing
        mode="popup"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
      type="buttons"
      width="50"
    >
      <dxi-button
        name="edit"
        icon="edit"
        hint="Düzenle"
      ></dxi-button>
    </dxi-column>
      <dxi-column dataField="name" caption="İsim" [allowEditing]="false">
        <dxi-validation-rule
          type="required"
          message="Name is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="email" caption="Mail">
        <dxi-validation-rule
          type="required"
          message="Email is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="password" caption="Şifre">
        <dxi-validation-rule
          type="required"
          message="Password is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="smtpHost" caption="Host">
        <dxi-validation-rule
          type="required"
          message="Host is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="port" caption="Port">
        <dxi-validation-rule
          type="required"
          message="Port is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="ssl" caption="Ssl" dataType="boolean">
      </dxi-column>
      <dxi-column dataField="subject" caption="Subject">
        <dxi-validation-rule
          type="required"
          message="Subject is required"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column
        dataField="replacedValues"
        caption="Özel İfadeler"
        [visible]="false"
      >
        <dxo-form-item
          editorType="dxTextArea"
          [editorOptions]="{ height: 120, autoResizeEnabled: true }"
        >
        </dxo-form-item>
      </dxi-column>
      <dxi-column dataField="body" caption="İçerik" [visible]="false">
        <dxi-validation-rule
          type="required"
          message="Body is required"
        ></dxi-validation-rule>

        <dxo-form-item
          [colSpan]="2"
          editorType="dxHtmlEditor"
          [editorOptions]="editorOptions"
        >
        </dxo-form-item>
      </dxi-column>
      <dxi-column type="buttons" [width]="110">
        <dxi-button name="edit"></dxi-button>
        <dxi-button
          hint="Test Maili Gönder"
          icon="email"
          [onClick]="sendTestMail"
        ></dxi-button>
      </dxi-column>
    </dx-data-grid>
  </div>

</div>

<div class="row">
  <div class="col-md-6">
    <h2 class="content-block"><i class="fa-solid fa-money-bill-transfer"></i> Havale Bilgileri</h2>
    <dx-data-grid
      [dataSource]="bankAccounts"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createBankAccount($event)"
      (onRowUpdating)="updateBankAccount($event)"
      (onRowRemoved)="deleteBankAccount($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="false"
        [allowAdding]="true"
      >
      </dxo-editing>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column
        type="buttons"
        width="50"
      >
        <dxi-button
          name="edit"
          icon="edit"
          hint="Düzenle"
        ></dxi-button>
      </dxi-column>
      <dxi-column dataField="bankaAdi" caption="Banka Adı">
        <dxi-validation-rule
          type="required"
          message="Banka adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- <dxi-column dataField="firmaAdi" caption="Firma Adı">
        <dxi-validation-rule
          type="required"
          message="Firma adı zorunludur"
        ></dxi-validation-rule>
      </dxi-column> -->
      <dxi-column dataField="hesapNo" caption="Hesap No">
        <dxi-validation-rule
          type="required"
          message="Hesap no zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="iban" caption="IBAN">
        <dxi-validation-rule
          type="required"
          message="IBAN zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="subeKodu" caption="Şube Kodu">
        <dxi-validation-rule
          type="required"
          message="Şube kodu zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>


